export default __webpack_public_path__ + "e5b003004f8e36cd31125886e0da5f1e.svg";